module.exports = __webpack_public_path__ + "02_cheeks.0777e1a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer3/02_cheeks.png
// module id = 5aoO
// module chunks = 0